// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Layout } from '../../components/index';
import {
  Content,
  Footer,
  Grid,
  Hero,
  HorizontalBig,
  HorizontalSmall,
  StyledButton,
} from './styles';
import Image1 from 'assets/images/brandIdentity/image-1.webp';
import Image2 from 'assets/images/brandIdentity/image-2.webp';
import Image3 from 'assets/images/brandIdentity/image-3.webp';
import Image4 from 'assets/images/brandIdentity/image-4.webp';
import Image5 from 'assets/images/brandIdentity/image-5.webp';
import Image6 from 'assets/images/brandIdentity/image-6.webp';
import Image7 from 'assets/images/brandIdentity/image-7.webp';

export const BrandIdentity = () => {
  const navigate = useNavigate();
  const routePath = useLocation();

  const onTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);

  return (
    <Layout noPadding>
      <Content>
        <Hero>
          <img src={Image1} alt='' />
        </Hero>
        <Grid>
          <img src={Image3} alt='' />
          <img src={Image2} alt='' />
        </Grid>
        <HorizontalBig>
          <img src={Image4} alt='' />
        </HorizontalBig>
        <HorizontalSmall>
          <img src={Image5} alt='' />
        </HorizontalSmall>
        <Grid>
          <img src={Image7} alt='' />
          <img src={Image6} alt='' />
        </Grid>
        <Footer>
          <StyledButton onClick={() => navigate('/')}>Go Back</StyledButton>
        </Footer>
      </Content>
    </Layout>
  );
};
